module.exports = __webpack_public_path__ + "static/media/cloud-left-mobile.cb3f6ff9.svg";